const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY
export default {
  RECAPTCHA_SITE_KEY,
  RECAPTCHA_SCRIPT_URL: `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`,
}
